<template>
  <main class="home">
    <BannerMultiProductComponent :items="banner_items" country="usa" lang="en" />
    <ProductNavComponent lang="en" />
    <!--<DeckComponent id="what" title="Coolest Development Services" description="We develop for you to exceed your goals. We are ready to build and release your solutions." variant="blue" :items="services" />-->
    <BannerTipComponent
      icon="https://cdn.systemico.net/systemico/icons/icon-systemico--color.svg"
      message="Show information to analyze your business, take decisions with clear information from different sources. We integrate to simplify your "
      author="Systemico Team"
      background="#333333"
      textColor="#f8f8f8"
    />
    <BannerBenefitsComponent
          title="Always improving our method to generate a smart development."
          :items="benefits"
          background="#fefefe"
          textColor="#444444"
    />
    <ProductDescriptionComponent id="features" title="Amazing Features and Extras" :characteristics="features" />
    <PresentationComponent id="features" title="Systemico / Services / Development / <b>API</b>" :topics="topics" lang="en" />
    <PlansComponent title="Development packages for you" :plans="plans" background="#9fcdff" />
    <BannerTipComponent
      icon="https://cdn.systemico.net/systemico/icons/icon-systemico--color.svg"
      message="Are you ready to start?"
      author="Systemico Team"
      background="#00308F"
      textColor="#f8f8f8"
    />
    <ContactComponent lang="en"/>
    <NewsSystemicoSection />
    <FooterSystemicoComponent lang="en" />
  </main>
</template>

<script>
// @ is an alias to /src
import HeaderSystemicoComponent from "../../packages/systemico.ui/components/headers/HeaderSystemicoComponent.vue";
import NewsSystemicoSection from "../../packages/systemico.ui/components/sections/NewsSystemicoSection.vue";
import BannerTipComponent from "../../packages/systemico.ui/components/banners/BannerTipComponent.vue";
import PresentationComponent from "../../packages/systemico.ui/components/slides/PresentationComponent.vue";
import FooterSystemicoComponent from "../../packages/systemico.ui/components/footers/FooterSystemicoComponent.vue";
import BannerMultiProductComponent from "../../packages/systemico.ui/components/banners/BannerMultiProductComponent.vue";
import BannerBenefitsComponent from "../../packages/systemico.ui/components/banners/BannerBenefitsComponent.vue";
import DeckComponent from "../../packages/systemico.ui/components/cards/DeckComponent.vue";
import ProductNavComponent from "../../packages/systemico.ui/components/navs/ProductNavComponent.vue";
import PlansComponent from "../../packages/systemico.ui/components/pricing/PlansComponent.vue";
import ProductDescriptionComponent
  from "../../packages/systemico.ui/components/contents/ProductDescriptionComponent.vue";
import ContactComponent from "../../packages/systemico.ui/components/contacts/ContactComponent.vue";

export default {
  name: 'CronView',
  data: function(){
    return {
      banner_items: [
        {
          id: 1,
          title: 'Cron Services',
          subtitle: 'Automate your processes and operations with smart bots to acquire data, generate actions or information, send notifications and more.',
          image: 'https://cdn.systemico.net/systemico/web/headers/header_53.png',
          backgroundImage: '',
          buttons: [
            { id: 1, text: 'Start your development', variant: 'primary', link: 'https://systemico.net/signup?context=developmen', icon:'patch-check-fill' },
            { id: 2, text: "I'm a happy client", variant: 'secondary', link: 'https://systemico.net/login?context=development', icon:'code-square' }
          ],
          show: true
        }
      ],
      features: [
        { id: 1, title: 'Application Monitor', description: 'Detect errors, warning and info in realtime.', image: 'https://cdn.systemico.net/systemico/images/screenshots/monitor_1.png' },
        { id: 2, title: 'Documentation System', description: 'Define and document your ENDPOINTs and share a link with the information for your developers or other stakeholders.', image: 'https://cdn.systemico.net/systemico/images/screenshots/wsmaker_1.png' },
        { id: 3, title: 'Execution Panel', description: 'Start, stop and restart bots and obtain the control over your solutions.', image: 'https://cdn.systemico.net/systemico/images/screenshots/wsmaker_1.png' },
      ],
      benefits: [
        { id: 1, title: 'Python', description: 'Python is powerful... and fast plays well with others runs everywhere is friendly & easy to learn is Open.', icon: 'https://cdn.systemico.net/systemico/icons/icon-code.svg' },
        { id: 2, title: 'Flask Framework', description: 'Flask is a micro web framework written in Python that is well-suited for building REST APIs due to its flexibility and simplicity.', icon: 'https://cdn.systemico.net/systemico/icons/icon--soporte.svg' },
        { id: 3, title: 'Documentation', description: 'We understand your needs and dreams, we are ready to help, share and improve.', icon: 'https://cdn.systemico.net/systemico/icons/icon--cool.svg' },
        { id: 4, title: 'Monitoring', description: 'We include a monitor to review exceptions and errors in real time.', icon: 'https://cdn.systemico.net/systemico/icons/icon-check--orange.svg' }
      ],
      services: [
        { id: 1, title: 'API development.', description: 'API development for REST and SOAP with testing endpoints and documentation.', image: "https://cdn.systemico.net/systemico/web/cards/headers/header-1.svg"},
        { id: 2, title: 'Bot Development.', description: 'API development for REST and SOAP with testing endpoints and documentation.', image: "https://cdn.systemico.net/systemico/web/cards/headers/header-2.svg"},
        { id: 3, title: 'Dashboards Development.', description: 'API development for REST and SOAP with testing endpoints and documentation.', image: "https://cdn.systemico.net/systemico/web/cards/headers/header-4.svg"},
        { id: 3, title: 'Cron Services.', description: 'API development for REST and SOAP with testing endpoints and documentation.', image: "https://cdn.systemico.net/systemico/web/cards/headers/header-3.svg"},
      ],
      topics: [
        { id: 1, topic: 'Brief', content: ['<b>Systemico develop bots using python and java</b>, each bot has an objective to complete a business goal, let us help you to automate your business and reduce the monotonous tasks.' +
          '<br><br><b>We are ready to integrate bots in your business processes.</b>'], image: '' },
        { id: 2, topic: 'Methodology', content: ['1. Define requirements for the bot. \n', '2. Defining acceptance criteria aligned to the business. \n', '3. Design a model with documentation. \n', '4. Implement the bot. \n', '5. Testing.', '6. Approval.', '7. Release to production.', '8. Send the access to the panel control.'], image: '' },
        { id: 3, topic: 'Innovative Aspects', content: ['1. Experience and knowledge.', '2. Multiple environments to test.', '3. Control panel 100% Web.', '4. Chat to interact with te team.', '5. Project Management Platform to monitor the project.', '6. Frameworks and tools available.'], image: '' },
        { id: 4, topic: 'Fanatical Support', content: 'Support online and available from <a href="https://systemico.net/">systemico.net</a> or authorized channels.', image: '' },
        { id: 5, topic: 'Thanks', content: '<b>Systemico</b> is the opportunity to create high quality technologies to innovate and add value to your services.', image: '' },
      ],
      plans: [
        {
          id: 1,
          title: 'Starter',
          description: 'Initial development for a small business, startup or a new product.',
          features: [
            { id: 1, value: '<b>20 hours of development.</b>' },
            { id: 2, value: 'Developed with Python <small class="font-italic">(Flask)</small>.' },
            { id: 3, value: 'Documentation included.' },
            { id: 4, value: '1 month of technical support.' },
            { id: 5, value: 'Endpoint beta for testing and acceptance.' },
            { id: 6, value: 'The Better practice of industry.' },
            { id: 7, value: 'Exceptions monitor included.' },
            { id: 8, value: 'Code for data analytics, reports, notifications, authentication and more.' },
          ],
          pricing: '$1000',
          frecuency: 'once',
          currency: 'USD',
          labelButton: 'Get Now',
          noteButton: 'We provide you a platform to manage your requirements, deliveries, billing and support.',
          link: 'https://systemico.net/signup?dplan=1'
        },
        {
          id: 1,
          title: 'Professional',
          description: 'Professional development for small business, startup or a new product.',
          features: [
            { id: 1, value: '<b>50 hours of development.</b>>' },
            { id: 2, value: 'Developed with Python <small class="font-italic">(Flask)</small>.' },
            { id: 3, value: 'Documentation included.' },
            { id: 4, value: '1 month of technical support.' },
            { id: 5, value: 'Endpoint beta for testing and acceptance.' },
            { id: 6, value: 'The Better practice of industry.' },
            { id: 7, value: 'Exceptions monitor included.' },
            { id: 8, value: 'Code for data analytics, reports, notifications, authentication and more.' },
          ],
          pricing: '$2500',
          frecuency: 'once',
          currency: 'USD',
          labelButton: 'Get Now',
          noteButton: 'We provide you a platform to manage your requirements, deliveries, billing and support.',
          link: 'https://systemico.net/signup?dplan=2'
        },
        {
          id: 1,
          title: 'ScaleUp',
          description: 'Large development for small business, startup or a new product.',
          features: [
            { id: 1, value: '<b>100 hours of development.</b>' },
            { id: 2, value: 'Developed with Python <small class="font-italic">(Flask)</small>.' },
            { id: 3, value: 'Documentation included.' },
            { id: 4, value: '1 month of technical support.' },
            { id: 5, value: 'Endpoint beta for testing and acceptance.' },
            { id: 6, value: 'The Better practice of industry.' },
            { id: 7, value: 'Exceptions monitor included.' },
            { id: 8, value: 'Code for data analytics, reports, notifications, authentication and more.' },
          ],
          pricing: '$5000',
          frecuency: 'once',
          currency: 'USD',
          labelButton: 'Get Now',
          noteButton: 'We provide you a platform to manage your requirements, deliveries, billing and support.',
          link: 'https://systemico.net/signup?dplan=3'
        }
      ]
    }
  },
  components: {
    ContactComponent,
    ProductDescriptionComponent,
    PlansComponent,
    PresentationComponent,
    ProductNavComponent,
    DeckComponent,
    BannerBenefitsComponent,
    BannerTipComponent,
    BannerMultiProductComponent,
    FooterSystemicoComponent,
    HeaderSystemicoComponent,
    NewsSystemicoSection
  }
}
</script>
<style lang="scss" scoped>

</style>
